import { render, staticRenderFns } from "./DropOffBody.vue?vue&type=template&id=7df701f6&scoped=true&"
import script from "./DropOffBody.vue?vue&type=script&lang=ts&"
export * from "./DropOffBody.vue?vue&type=script&lang=ts&"
import style0 from "./DropOffBody.vue?vue&type=style&index=0&id=7df701f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df701f6",
  null
  
)

export default component.exports